import type { NeteaseTrackMetadata } from "@shared/types";

export function canAttemptNeteaseLogin(metadata: NeteaseTrackMetadata | null): boolean {
  return !metadata
    || metadata.playbackStatus === "restricted"
    || metadata.playbackStatus === "unknown";
}
